// UI
import {Box, Stack, Typography, Paper, Button, useTheme} from "@mui/material";
import { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { tokens } from "../../theme";

// icon
import CircularProgress from '@mui/material/CircularProgress';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

// store
import paymentsStore from '../../store/paymentsStore';
import {observer} from "mobx-react-lite";

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import BillingService from "../../services/BillingService";
// import AnaliticsBillings from "../AnaliticsBillings/AnaliticsBillings"

// Visually hidden input for accessibility
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const ProviderPayments = ({provider}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [loading, setLoading] = useState(false);
    const [paymets, setPayments] = useState([])
    // const [billings, setBillings] = useState([]);

    // const [currentYear, setCurrentYear] = useState(dayjs().startOf('month'))
    // const [timeStart, setTimeStart] = useState(dayjs().startOf('month').unix());
    // const [timeEnd, setTimeEnd] = useState(dayjs().endOf('day').unix());

    useEffect(() => {
        setPayments(paymentsStore.getPayments(provider.id))
    }, [provider]);  

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
            const text = e.target.result;
            parse1CFile(text);
        };
        reader.readAsText(file, 'windows-1251'); // 1С часто в CP1251
    };

    const searchUsers = async (payer_inn) => {
        const result = []
        const billing_users = await BillingService.billing_users(0, 10, "inn:" + payer_inn, provider.id);
        for (const user of billing_users.data.billingUsers) {
            const responseBillingUserAccounts = await BillingService.billing_users_accounts("GET", user.billing_id, user.user_id);
            for (const account of responseBillingUserAccounts.data.accounts) {
                account['billing_id'] = user.billing_id
                account['user_id'] = user.user_id
                account['full_name'] = user.full_name
                result.push(account)
            }
        }
        return await result;
    };

    const parse1CFile = async (text) => {
        setLoading(true)
        const lines = text.split('\n');
        const documents = [];
        let currentPay = null;
        var number = 1
        for (const line of lines) {
            if (line.startsWith('СекцияДокумент')) {
                currentPay = {
                    "number": 0,
                    "billing_id": null,
                    "account_id": null,
                    "user_id": null,
                    "payment_incurrency": null,
                    "currency_id": null,
                    "actual_date": Date.now() / 1000,
                    "payment_enter_date": null,
                    "burn_time": 0,
                    "method": null,
                    "admin_comment": null,
                    "comment": null,
                    "payment_ext_number": "",
                    "payment_to_invoice": 0,
                    "turn_on_inet": 1,
                    "skip": 0,
                    "carried_out": 0,
                    "accounts": []
                };
                
            } else if (line.startsWith('КонецДокумента')) {
                currentPay.number = number
                number = number + 1
                if (currentPay.payer_inn == 7751521793) {
                    currentPay.skip = 1
                }
                else {
                    const accounts = await searchUsers(currentPay.payer_inn)
                    if (accounts.length == 1) {
                        currentPay.account_id = accounts[0].account_id
                        currentPay.user_id = accounts[0].user_id
                    }
                    currentPay.accounts = accounts
                }

                documents.push(currentPay);
                currentPay = null;
            } else if (currentPay) {
                const [key, value] = line.split('=');
                if (key && value) {
                    switch (key.trim()) {
                        case "Дата":
                            currentPay.payment_enter_date = value.trim()
                            break;
                        case "Номер":
                            currentPay.payment_ext_number = value.trim()
                            break;
                        case "Плательщик":
                            currentPay.payer = value.trim()
                            break;
                        case "ПлательщикИНН":
                            currentPay.payer_inn = value.trim()
                            break;
                        case "ПолучательИНН":
                            if (value.trim() != 7751521793) {
                                currentPay.skip = 1
                            }
                            break;
                        case "Сумма":
                            currentPay.payment_incurrency = value.trim()
                            break;
                        case "НазначениеПлатежа":
                            currentPay.admin_comment = value.trim()
                            currentPay.comment = value.trim()
                            break;
                        default:
                            currentPay[key.trim()] = value.trim();
                    }
                }
            }
        };
        paymentsStore.setPayments(provider.id, documents);
        setPayments(documents)
        console.log(documents); // Обработанные данные
        setLoading(false)
    };

    return (
        <Stack spacing={2} width={"100%"}>
            <Paper sx={{p: 1, minWidth: "320px"}}>
                <Stack
                    direction="row"
                    spacing={{ xs: 1, sm: 2 }}
                    useFlexGap
                    sx={{ flexWrap: 'wrap' }}
                >
                    <Typography variant="h2">{provider.name}</Typography>
                    <Button
                        component="label"
                        role={undefined}
                        variant="contained"
                        tabIndex={-1}
                        startIcon={<CloudUploadIcon />}
                        sx={{
                                backgroundColor: colors.greenAccent[700],
                                color: colors.grey[100],
                                fontSize: "14px",
                                fontWeight: "bold",
                                padding: "10px 20px",
                            }}
                        >
                        Upload files
                        <VisuallyHiddenInput
                            type="file"
                            onChange={handleFileUpload}
                            // multiple // Optional: allow multiple files
                        />
                    </Button>
                </Stack>
            </Paper>
            {!loading 
                ?   <Payments data={paymets} />
                :   <Box sx={{display: 'flex', justifyContent: 'center', p: 3 }}>
                        <CircularProgress color="primary" />
                    </Box>
            }
        </Stack>
    )};

export default observer(ProviderPayments);

const Payments = ({provider, data}) => {

    

    return (
        <table border="1">
            <thead>
                <tr>
                    <th></th>
                    <th>User ID</th>
                    <th>Account ID</th>
                    <th>Дата перевода</th>
                    <th>Плательщик</th>
                    <th>Сумма</th>
                    <th>Номер</th>
                    <th>Назначение платежа</th>
                    <th>skip</th>
                    <th>corried out</th>
                </tr>
            </thead>
            <tbody>
                {data.map((doc, index) => (
                    <>
                    <tr key={index}>
                        <td>{doc.number}</td>
                        <td>{doc.user_id}</td>
                        <td>{doc.account_id}</td>
                        <td>{doc.payment_enter_date}</td>
                        <td>{doc.payer} / {doc.payer_inn}</td>
                        {/* <td>{doc.Получатель} {doc.ПолучательИНН}</td> */}
                        <td>{doc.payment_incurrency}</td>
                        <td>{doc.payment_ext_number}</td>
                        <td>{doc.admin_comment}</td>
                        <td>{doc.skip}</td>
                        <td>{doc.carried_out}</td>
                    </tr>
                    
                    {doc.accounts.map((account, account_i) => (
                        <tr key={account_i}>
                            <td></td>
                            <td>{account.billing_id}</td>
                            <td>{account.account_id}</td>
                            <td>{account.balance}</td>
                        </tr>
                    ))}
                    </>
                ))}
            </tbody>
        </table>
    )
}